module.exports = __webpack_public_path__ + "img/107-orkney islands.9b4e7d1d.svg";